import {actions as A} from '../constants/actions';

const defaultState = {
  payload: {},
};

export default (state = defaultState, {type, payload}) => {
  switch(type) {
    case A.SET_STEP_PAYLOAD:
      return {...state, payload};

    default:
      return state;
  }
}
